import { type Amount } from '../../../common/amount'

export enum ChargeUnit {
  hour = 'hour',
  km = 'km',
  mile = 'mile',
  pounds = 'pounds',
  kilograms = 'kilograms',
}

export enum ChargeCategory {
  labour = 'labour',
  tripAndTravel = 'tripAndTravel',
  additionalCharges = 'additionalCharges',
  protectiveMaterial = 'protectiveMaterial',
}

export enum ChargeDescription {
  movingLabour = 'movingLabour',
  packingLabour = 'packingLabour',
  movingByWeight = 'movingByWeight',
  packingByWeight = 'packingByWeight',
  travelLabour = 'travelLabour',
  transportLabour = 'transportLabour',

  travelTruckFeePerKilometer = 'travelTruckFeePerKilometer',
  transportTruckFeePerKilometer = 'transportTruckFeePerKilometer',
  fixedTruckFee = 'fixedTruckFee',
  transportationChargeByWeight = 'transportationChargeByWeight',
  shuttleServiceByWeight = 'shuttleServiceByWeight',
  longDistanceFuelSurcharge = 'longDistanceFuelSurcharge',

  additionalChargesOvernight = 'additionalChargesOvernight',
  additionalChargesStairs = 'additionalChargesStairs',
  additionalChargesStairsByWeight = 'additionalChargesStairsByWeight',
  additionalChargesSpecialServices = 'additionalChargesSpecialServices',
  additionalChargesSpecialItems = 'additionalChargesSpecialItems',
  additionalChargesAreaByWeight = 'additionalChargesAreaByWeight',
  additionalChargesScalingFee = 'additionalChargesScalingFee',

  protectiveMaterialProduct = 'protectiveMaterialProduct',

  customCharge = 'customCharge',
  customChargeMw = 'customChargeMw',
}

export type Charge = {
  pricingCategory: ChargeCategory
  description: ChargeDescription
  overrideDescription?: string
  item?: string
  quantity: number
  unit?: ChargeUnit
  unitPrice: Amount
  subtotal: Amount
  taxable?: boolean
}
